import { render } from "./eventComponent.vue?vue&type=template&id=3f644838&scoped=true"
import script from "./eventComponent.vue?vue&type=script&lang=js"
export * from "./eventComponent.vue?vue&type=script&lang=js"

import "./eventComponent.vue?vue&type=style&index=0&id=3f644838&scoped=true&lang=css"
import "./eventComponent.vue?vue&type=style&index=1&id=3f644838&lang=css"

import exportComponent from "F:\\work\\rahul\\mangal karyala\\gore-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f644838"]])

export default __exports__